import React from 'react'
import Ionicon from "react-ionicons";
import { currency } from './../../../../../../helpers/';

export const AddToCartItemProfile = props => {
        const { item, purchased, onAddToCartClicked, cancelModal } = props;

        return (
            <div className="product-box">
                <h3 className="h3 product-title">{ item.name }</h3>
                <div className="price-default">
                    <span className="price">{ currency( item.price.value ) } </span>
                    <span className="vat">{ `ex ${ currency.taxType() }` }</span>
                </div>
                <ul className="buttons-left">
                    <li>
                        <button
                            type="button"
                            className="btn btn-primary--ghost"
                            onClick={ cancelModal } >
                            <span className="label">Back</span>
                        </button>
                    </li>
                    <li>
                        {
                            !purchased ?
                                <button type="button" className="btn btn-primary icon-right" onClick={ onAddToCartClicked }>
                                    <span className="label">Add To Basket</span>
                                    <span className="icon"><Ionicon icon="ion-ios-cart"/></span>
                                </button>
                                :
                                <mark className="btn btn-primary disabled btn-icon-right">
                                    <span className="label">Added to your basket</span>
                                    <span className="icon"><Ionicon icon="ion-checkmark"/></span>
                                </mark>
                        }
                    </li>
                </ul>
            </div>
        );
}

export default AddToCartItemProfile;


// WEBPACK FOOTER //
// src/client/components/site/features/profile/elements/ui/AddToCartItemProfile.js